import { JsonApiPayload, ModelLike } from './JsonApiPayload';
import { RateDetailInfo } from 'services/interfaces/RateDetailInfo';

type RateType = 'daily' | 'monthly';
type RateStrategy = 'calculated' | 'prorated';

export class QuoteRequest extends JsonApiPayload {
  siteTypeId: string;
  arrivalDate: string;
  departureDate: string;
  adults: number;
  children: number;
  pets: number;
  rateId: string;
  rateType: RateType;
  rateOverride: number;
  monthlyRateStrategy: RateStrategy;
  discountId: string;

  static new(model?: ModelLike) {
    return super.fill(new this(), model);
  }

  static getRaw(instance: QuoteRequest) {
    return super._getRaw(instance);
  }
}

export class QuotePayload extends JsonApiPayload {
  id: string;
  siteTypeId: string;
  rateId: string;
  discountId: string;
  arrivalDate: string;
  departureDate: string;
  adults: number;
  children: number;
  pets: number;
  rateOverride: number;
  rateType: string;
  monthlyRateStrategy: string;
  label: string;
  rateDetail: RateDetailInfo;
  numberOfNights: number;
  numberOfAvailableSites: number;
  subtotal: number;
  tax: number;
  taxDetail: TaxDetailInfo[];
  total: number;
  transactionFee: number;
  deposit: number;
  discount: number;
  updatedAt: string;
  createdAt: string;

  static new(model?: ModelLike) {
    return super.fill(new this(), model);
  }

  static getSchema() {
    return super._getSchema(this, []);
  }

  static getRaw(instance: QuotePayload) {
    return super._getRaw(instance);
  }
}

export type QuoteResponse = QuotePayload;

export type TaxDetailInfo = {
  // type: string;
  // code: string;
  glAccountId: string;
  label: string;
  description: string;
  memo: string;
  amount: number;
  unitPrice: number;
  taxRate: number;
}
